import { Image, Upload } from "antd";
import RWebcam from "react-webcam";
import styled from "styled-components";

const MultimediaField = styled(Upload)`
  width: 100%;
`;

const Container = styled.div`
  border: 1px dotted #222;
  padding: 10px;
  border-radius: 15px;
`

const WebCamContainer = styled.div`
  text-align: center;
  background-color: "#eee";
  padding: 10px;
  border-radius: 15px;
`;

const CaptureViewport = styled.div`
  width: 70%;
  max-width: 70%;
  margin: 0 auto;
`;

const WebCam = styled(RWebcam)`
  width: 100%;
  max-width: 100%;
  display: block;
`;

const CapturePreview = styled(Image)`
  &.ant-image {
    display: block;
    width: 100%;
    max-width: 100%;
  }

  .ant-image-img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    cursor: pointer;
  }
`;

const CenterContainer = styled.div`
  text-align: center;
`;


export {
  MultimediaField,
  WebCam,
  Container,
  WebCamContainer,
  CaptureViewport,
  CenterContainer,
  CapturePreview,
};
